import {
	NgModule,
	Component,
	ModuleWithProviders,
	Optional,
	SkipSelf
} from '@angular/core';
import { ApplicationService } from '../shared/services/application.service';
import { SalesEntityService } from '../layout/sales-entity/sales-entity-service/sales-entity-service';
import { SeatService } from 'app/layout/sales-entity/sales-entity-service/seat-service';
import { UserAccessService } from '../shared/services/user-access.service';
import { CacheService } from '../shared/services/cache.service';
import { CommonModule } from '@angular/common';
import { DashboardService } from '../shared/services/dashboard.service';
import { ResidualsService } from '../layout/residuals/residuals.service';
import { FormatService } from '../shared/services/format.service';
import { ApprovalsService } from 'app/shared/services/approvals.service';
import { FormsValidationService } from '../shared/services/formsValidation.service';
import { EricCacheService } from '../shared/services/ericCache.service';
import { AnnouncementsService } from 'app/layout/announcements/announcements.service';

/*
https://angular.io/guide/singleton-services
This module is designed to force singleton instances of providers
Add your provider to the list of providers and it automagically becomes a singleton.

IMPORTANT NOTE:
YOU MUST REMOVE ANY PROVIDERS OF THE SERVICE IF IT'S ALREADY BEING PROVIDED.
THOSE WILL NOT BE SINGLETONS AND MUST BE REMOVED.
*/
@NgModule({
	/* If not using forRoot() you can list providers here */
	imports: [CommonModule],
	declarations: [],
	providers: [],
	exports: []
})
export class CoreModule {
	// Returns a core module
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: CoreModule,
			providers: [
				ApplicationService,
				SalesEntityService,
				SeatService,
				UserAccessService,
				CacheService,
				EricCacheService,
				DashboardService,
				ResidualsService,
				UserAccessService,
				ApprovalsService,				
				AnnouncementsService,
				FormatService,
				FormsValidationService
			]
		};
	}

	// Magic that prevents it from being a non-singleton
	constructor(
		@Optional()
		@SkipSelf()
		parentModule: CoreModule
	) {
		if (parentModule) {
			throw new Error(
				'CoreModule is already loaded. Import it in the AppModule only'
			);
		}
	}
}
